import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  KeyboardArrowRight,
  KeyboardArrowLeft,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
} from "@mui/icons-material";

const InvoiceDetails = ({
  formData,
  setFormData,
  currentOrderIndex,
  totalOrders,
  onPrev,
  onNext,
  onFirst,
  onLast,
}) => {
  // Debug: Log the props received
  console.log("InvoiceDetails props:", {
    currentOrderIndex,
    totalOrders,
    orderNumber: formData.order_number,
  });

  // REMOVED: Don't set default date here - it overwrites the loaded order date
  // The date should be set by loadOrderData in OrderForm.js

  // Note: order_number is now managed by the parent OrderForm component
  // No need to override it here

  // Format date with time for display
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    
    try {
      let date;
      
      // Handle different date formats
      if (dateString.includes("T")) {
        // ISO format with time (YYYY-MM-DDTHH:mm:ss or YYYY-MM-DDTHH:mm:ss.sssZ)
        date = new Date(dateString);
      } else if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        // YYYY-MM-DD format, use midnight time
        date = new Date(dateString + "T00:00:00");
      } else {
        // Try to parse as-is
        date = new Date(dateString);
      }
      
      // Check if date is valid
      if (isNaN(date.getTime())) {
        return dateString;
      }
      
      // Format: DD-MM-YYYY HH:MM:SS
      // Using toLocaleString for IST timezone
      const options = {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };
      
      const formatted = date.toLocaleString("en-GB", options);
      // Convert from DD/MM/YYYY, HH:MM:SS to DD-MM-YYYY HH:MM:SS
      return formatted.replace(/, /, " ").replace(/\//g, "-");
    } catch (error) {
      console.error("Error formatting date:", error);
      return dateString;
    }
  };

  return (
    <Col className="sales-form-section">
      <Row>
        <Col xs={12} md={12}>
          <div style={{ marginBottom: "0.5rem" }}>
            <div>
              Date: {formatDateTime(formData.date)}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={12}>
          <div style={{ marginBottom: "0.5rem" }}>
            <div>Order Number: {formData.order_number}</div>
          </div>
        </Col>
      </Row>
      {/* <Row>
              <Col xs={12}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: 8,
                  }}
                >
                  <button
                    type="button"
                    onClick={onFirst}
                    disabled={currentOrderIndex <= 0}
                    style={{
                      border: "none",
                      background: "none",
                      fontSize: 20,
                      color: currentOrderIndex <= 0 ? "#ccc" : "#a36e29",
                      cursor: currentOrderIndex <= 0 ? "not-allowed" : "pointer",
                      marginRight: 0,
                    }}
                    title="First"
                  >
                    <KeyboardDoubleArrowLeft />
                  </button>
                  <button
                    type="button"
                    onClick={onPrev}
                    disabled={currentOrderIndex <= 0}
                    style={{
                      border: "none",
                      background: "none",
                      fontSize: 20,
                      color: currentOrderIndex <= 0 ? "#ccc" : "#a36e29",
                      cursor: currentOrderIndex <= 0 ? "not-allowed" : "pointer",
                      marginRight: 0,
                    }}
                    title="Previous"
                  >
                    <KeyboardArrowLeft />
                  </button>
      
                  <span
                    style={{
                      fontSize: 13,
                      color: "#888",
                      minWidth: 60,
                      textAlign: "center",
                    }}
                  >
                    {currentOrderIndex + 1} / {totalOrders}
                  </span>
      
                  <button
                    type="button"
                    onClick={onNext}
                    disabled={currentOrderIndex >= totalOrders - 1}
                    style={{
                      border: "none",
                      background: "none",
                      fontSize: 20,
                      color:
                        currentOrderIndex >= totalOrders - 1 ? "#ccc" : "#a36e29",
                      cursor:
                        currentOrderIndex >= totalOrders - 1
                          ? "not-allowed"
                          : "pointer",
                    }}
                    title="Next"
                  >
                    <KeyboardArrowRight />
                  </button>
                  <button
                    type="button"
                    onClick={onLast}
                    disabled={currentOrderIndex >= totalOrders - 1}
                    style={{
                      border: "none",
                      background: "none",
                      fontSize: 20,
                      color:
                        currentOrderIndex >= totalOrders - 1 ? "#ccc" : "#a36e29",
                      cursor:
                        currentOrderIndex >= totalOrders - 1
                          ? "not-allowed"
                          : "pointer",
                    }}
                    title="Last"
                  >
                    <KeyboardDoubleArrowRight />
                  </button>
                </div>
              </Col>
            </Row> */}
      <Row>
        <Col
          xs={12}
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <button
              type="button"
              onClick={onFirst}
              disabled={currentOrderIndex <= 0}
              style={{
                border: "none",
                background: "none",
                fontSize: 20,
                color: currentOrderIndex <= 0 ? "#ccc" : "#a36e29",
                cursor: currentOrderIndex <= 0 ? "not-allowed" : "pointer",
                marginRight: 4,
              }}
              title="First"
            >
              <KeyboardDoubleArrowLeft />
            </button>

            <button
              type="button"
              onClick={onPrev}
              disabled={currentOrderIndex <= 0}
              style={{
                border: "none",
                background: "none",
                fontSize: 20,
                color: currentOrderIndex <= 0 ? "#ccc" : "#a36e29",
                cursor: currentOrderIndex <= 0 ? "not-allowed" : "pointer",
                marginRight: 4,
              }}
              title="Previous"
            >
              <KeyboardArrowLeft />
            </button>

            {/* <span
              style={{
                fontSize: 13,
                color: "#888",
                margin: "0 4px",
                minWidth: 40,
                textAlign: "center",
              }}
            >
              {currentOrderIndex === -1 ? "?" : totalOrders - currentOrderIndex} / {totalOrders}
            </span> */}
            <span
              style={{
                fontSize: 13,
                color: "#888",
                minWidth: 60,
                textAlign: "center",
              }}
            >
              {currentOrderIndex + 1} / {totalOrders}
            </span>

            <button
              type="button"
              onClick={onNext}
              disabled={currentOrderIndex >= totalOrders - 1}
              style={{
                border: "none",
                background: "none",
                fontSize: 20,
                color:
                  currentOrderIndex >= totalOrders - 1 ? "#ccc" : "#a36e29",
                cursor:
                  currentOrderIndex >= totalOrders - 1
                    ? "not-allowed"
                    : "pointer",
                marginRight: 4,
              }}
              title="Next"
            >
              <KeyboardArrowRight />
            </button>

            <button
              type="button"
              onClick={onLast}
              disabled={currentOrderIndex >= totalOrders - 1}
              style={{
                border: "none",
                background: "none",
                fontSize: 20,
                color:
                  currentOrderIndex >= totalOrders - 1 ? "#ccc" : "#a36e29",
                cursor:
                  currentOrderIndex >= totalOrders - 1
                    ? "not-allowed"
                    : "pointer",
              }}
              title="Last"
            >
              <KeyboardDoubleArrowRight />
            </button>
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default InvoiceDetails;
